export class ReduxStore {
    static auth: string = 'Auth';
}
